module.exports = __webpack_public_path__ + "img/accessory_shirt_08.d7e73493.svg";